export default __webpack_public_path__ + "static/media/PAFI_Pengumuman RUPS 2021.dd58e47c.pdf";